import axios from 'axios';
import { 
  SET_FOOTER_MODAL, SET_SLIDING_PANEL, SET_PROGRESS_MODAL, SET_DELETE_MODAL, 
  SET_UNAUTH_MODAL, SET_NONREFUND_MODAL, SET_EXPIRED_MODAL, SET_LOCKIN_MODAL,
  SET_INCLUDE_MODAL, SET_PLANNER_MODAL 
} from './types';
import { authHash } from '../lib/crypto';
import cookie from "js-cookie";

export const authToken = async () => {
  const response = await axios.get(`${process.env.REACT_APP_GRAPH_API_URL}auth/token?hash=${authHash()}`);
  const token = await response.data.token;
  cookie.set("ap.token", token);
}


/**
 * Slack webhook
 */
export const SlackWebhook = (slackWebhook, payload) => {

    const config = {
      headers:{
        'Content-type': 'application/x-www-form-urlencoded'
      }
    };
  
    return (dispatch) => {
      if (process.env.NODE_ENV === 'production'){
        axios.post(slackWebhook, JSON.stringify(payload), config).then(response => {
          //console.log(response)
        });
      }
    }
  }
  

 /**
  * Footer modal
  */
 export const ToggleFooterModal = (link, isOpen) => {
  return dispatch => dispatch({type:SET_FOOTER_MODAL, payload:{link, isOpen}})
}

export const ToggleSlidingPanel = (trip, builder, itinerary) => {
  return async dispatch => await dispatch({type:SET_SLIDING_PANEL, payload:{trip, builder, itinerary}});
}

/**
* Payment progress modal
*/
export const ToggleProgressModal = (value) => {
  return dispatch => dispatch({type:SET_PROGRESS_MODAL, payload:value})
}

/**
* Delete modal
*/
export const ToggleDeleteModal = (value) => {
  return dispatch => dispatch({type:SET_DELETE_MODAL, payload:value})
}

/**
* Unauthorised modal
*/
export const ToggleUnauthModal = (value) => {
  return dispatch => dispatch({type:SET_UNAUTH_MODAL, payload:value})
}

/**
* non refund modal
*/
export const ToggleNonRefundModal = (value) => {
  return dispatch => dispatch({type:SET_NONREFUND_MODAL, payload:value})
}


/**
* expired modal
*/
export const ToggleExpireModal = (value) => {
  return dispatch => dispatch({type:SET_EXPIRED_MODAL, payload:value})
}


/**
* lockin modal
*/
export const ToggleLockInModal = (value) => {
  return dispatch => dispatch({type:SET_LOCKIN_MODAL, payload:value})
}


/**
* Include modal
*/
export const ToggleIncludeModal = (value) => {
  return dispatch => dispatch({type:SET_INCLUDE_MODAL, payload:value})
}

/**
* Planner modal
*/
export const TogglePlannerModal = (value) => {
  return dispatch => dispatch({type:SET_PLANNER_MODAL, payload:value})
}







